import { defineStore } from 'pinia'

export interface ErrorStoreState {
  backRoutePath: null | string
  errorCode: '403' | '404' | '500' | null
  isRouteResolutionPending: boolean
  openErrorView: boolean
}

export const useErrorStore = defineStore('ErrorStore', {
  actions: {
    resetError() {
      this.backRoutePath = null
      this.errorCode = null
      this.openErrorView = false
    },
    resolveHistoryBackRoute(): null | string {
      const historyBack = window.history.state?.back

      if (typeof historyBack !== 'string' || historyBack.length === 0) {
        return null
      }

      if (!historyBack.startsWith('/')) {
        return null
      }

      return historyBack
    },
    setError(code: '403' | '404' | '500', backRoutePath?: null | string) {
      this.backRoutePath = backRoutePath ?? this.resolveHistoryBackRoute()
      this.errorCode = code
      this.openErrorView = true
    },
    setRouteResolutionPending(isPending: boolean) {
      this.isRouteResolutionPending = isPending
    },
  },
  state: (): ErrorStoreState => ({
    backRoutePath: null,
    errorCode: null,
    isRouteResolutionPending: false,
    openErrorView: false,
  }),
})
